import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      videoList: [],
      selectedCourseIdx: 0,
      majorList: [],
      activeMajorIdx: 0
    };
  },
  created: function() {
    // 加载课程列表
    this.loadMajorList();
  },
  methods: {
    async loadMajorList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest("/app/major/majors", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.majorList = res.data;
        this.loadVideoCourseList();
      }
      loadingInstance.close();
    },
    async loadVideoCourseList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const params = { majorId: this.majorList[this.activeMajorIdx].majorId };
      const res = await httpRequest("/app/course/video/courses", "get", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.videoList = res.data;
      }
      loadingInstance.close();
    },
    go2VideoContentPage(video) {
      if (video.canBrowse) {
        this.$router.push({
          path: "/videoCourse",
          query: {
            vcId: video.vcId,
            csId: video.csId
          }
        });
      }
    }
  }
};
